import { io } from "socket.io-client"

const connection_url = process.env.REACT_APP_IMAGE_PATH

export const socket = io(connection_url)
